import React from "react";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
const ErrorLog = [
  [
    "Error logs",
    "/admin/error-logs",
    <ErrorOutlineRoundedIcon
      sx={{ fontSize: "2rem", ml: "0.3rem" }}
    ></ErrorOutlineRoundedIcon>,
  ],
];
export default ErrorLog;
